import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import { ContentItemPlusPrimary } from "scmp-app/components/content/content-item-render/variants/plus-primary";
import { Cover } from "scmp-app/components/content/content-item-render/variants/plus-primary/styles";

export const StyledContentItemPlusPrimary = styled(ContentItemPlusPrimary)`
  flex-direction: column;
  ${Cover} {
    inline-size: 100%;
    max-inline-size: 296px;

    img {
      inline-size: 100%;
      max-inline-size: 296px;
    }
  }

  ${theme.breakpoints.up("desktop")} {
    ${Cover} {
      max-inline-size: unset;
      img {
        max-inline-size: unset;
      }
    }
  }
`;

export const ContentItemContainer = styled.div`
  ${StyledContentItemPlusPrimary}:nth-child(n+2) {
    margin-block-start: 16px;
    border-block-start: 1px solid rgba(0, 0, 0, 0.2);

    padding-block-start: 16px;
  }
`;

export const Container = styled.div``;
